import { httpDelete, httpGet, httpGetResponse, httpPost, httpPut } from '../../../api/httpClient';

export const FILE_CONTEXTS_PATH = '/admin/file-contexts';
export interface FileContextValues {
  context_name: string;
  context_code: string;
  context_entity_id: number;
}
export interface FileContext extends FileContextValues {
  context_id: number;
  context_is_public: boolean;
  context_is_system: boolean;
}
export interface FileEntity {
  entity_id: number;
  entity_code: string;
  entity_name: string;
}
export interface FileContextFilters {
  search: string;
  entity: string;
  sort: string;
  page: number;
}
export const fileContextsApi = {
  list(filters: FileContextFilters) {
    const params: Record<string, string> = { search: filters.search, sort: filters.sort, page: String(filters.page), per_page: '20' };
    if (filters.entity) params.context_entity_id = filters.entity;
    return httpGetResponse<FileContext[]>('/v1/file-context', params);
  },
  entities: () => httpGet<FileEntity[]>('/v1/file-context/entities'),
  get: (id: number) => httpGet<FileContext>(`/v1/file-context/${id}`),
  create: (values: FileContextValues) => httpPost<FileContext>('/v1/file-context', values),
  update: (id: number, values: FileContextValues) => httpPut<FileContext>(`/v1/file-context/${id}`, values),
  remove: (id: number) => httpDelete(`/v1/file-context/${id}`),
};
